import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: "extend",
    loadChildren: () => import("./features/omnichannel-extend/omnichannel-extend.module").then(m => m.OmnichannelExtendModule)
  },
  { path: '**', pathMatch: 'full', redirectTo: 'extend' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
